<div *ngIf="configForm && configData" class="config-container" [formGroup]="configForm">
  <h2 class="config-title">Change Parameters</h2>

  <mat-tab-group class="config-tabs" animationDuration="500ms">
    <!-- KBF Factors -->
    <mat-tab label="KBF Factors">
      <div class="tab-content">
        <div class="factor-card" *ngFor="let factor of configData.kbf_factors">
          <h3 class="factor-title">{{ factor | titlecase }}</h3>
          <div *ngIf="configForm.get(factor)" [formGroupName]="factor" class="factor-grid">
            <mat-form-field appearance="outline">
              <mat-label>Min</mat-label>
              <input matInput type="number" formControlName="min">
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Max</mat-label>
              <input matInput type="number" formControlName="max">
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Step</mat-label>
              <input matInput type="number" formControlName="step">
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Max Increase Factor</mat-label>
              <input matInput type="number" formControlName="max_increase_factor">
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Type</mat-label>
              <input matInput formControlName="type" readonly>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Direction</mat-label>
              <mat-select formControlName="direction">
                <mat-option value="up">Up</mat-option>
                <mat-option value="down">Down</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>
    </mat-tab>

    <!-- Quality Cost Factors -->
    <mat-tab label="Quality Cost Factors">
      <div class="tab-content">
        <div class="factor-card" *ngFor="let factor of configData.quality_cost_factors">
          <h3 class="factor-title">{{ factor | titlecase }}</h3>
          <div [formGroupName]="factor" class="factor-grid">
            <ng-container *ngFor="let field of ['min','max','step','max_increase_factor']">
              <mat-form-field appearance="outline">
                <mat-label>{{ field | titlecase }}</mat-label>
                <input matInput type="number" [formControlName]="field">
              </mat-form-field>
            </ng-container>
          </div>
        </div>
      </div>
    </mat-tab>

    <!-- Revenue & Cost -->
    <mat-tab label="Revenue & Cost">
      <div class="tab-content">
        <div class="factor-card" *ngFor="let factor of ['actual_revenue','actual_aftermarket_revenue','quarter_cost_hp']">
          <h3 class="factor-title">{{ factor | titlecase }}</h3>
          <div [formGroupName]="factor" class="factor-grid">
            <ng-container *ngFor="let field of ['min','max','step','max_increase_factor']">
              <mat-form-field appearance="outline">
                <mat-label>{{ field | titlecase }}</mat-label>
                <input matInput type="number" [formControlName]="field">
              </mat-form-field>
            </ng-container>
          </div>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>

  <div class="submit-row">
    <button mat-raised-button color="primary" class="save-btn" (click)="onSubmit()">Save Changes</button>
  </div>
</div>
